"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModal = exports.Z_INDEX = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_use_1 = require("react-use");
var NoScroll_1 = __importDefault(require("../../../utils/NoScroll"));
var Portal_1 = require("../../../utils/Portal");
var styles_1 = require("./styles");
exports.Z_INDEX = styles_1.COVER_Z_INDEX + 1;
var getFocusableElements = function (wrapper) {
    return __spreadArray([], __read(wrapper.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]')));
};
var getTriggerElement = function () {
    return typeof document !== 'undefined' ? document.activeElement : null;
};
var BaseModal = function (_a) {
    var children = _a.children, onClose = _a.onClose, title = _a.title;
    var containerRef = react_1.default.useRef(null);
    var coverRef = react_1.default.useRef(null);
    var triggerElement = react_1.default.useRef(getTriggerElement());
    var portalElement = react_1.default.useMemo(function () {
        if (typeof document !== 'undefined') {
            return document.getElementById(Portal_1.PORTAL_ID);
        }
        return undefined;
    }, []);
    var handleClickCover = function (e) {
        if (e.target === coverRef.current) {
            onClose();
        }
    };
    react_1.default.useEffect(function () {
        var _a;
        if (containerRef.current) {
            (_a = getFocusableElements(containerRef.current)[0]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [containerRef]);
    react_1.default.useEffect(function () { return function () {
        var _a;
        (_a = triggerElement.current) === null || _a === void 0 ? void 0 : _a.focus();
    }; }, []);
    var handleTab = react_1.default.useCallback(function (event) {
        if (containerRef.current) {
            var focusableElements = getFocusableElements(containerRef.current);
            if (focusableElements.length === 1) {
                event.preventDefault();
            }
            else {
                var firstFocusable = focusableElements[0];
                var lastFocusable = focusableElements[focusableElements.length - 1];
                if (event.shiftKey) {
                    if (document.activeElement === firstFocusable) {
                        event.preventDefault();
                        firstFocusable.focus();
                    }
                }
                else {
                    if (document.activeElement === lastFocusable) {
                        event.preventDefault();
                        lastFocusable.focus();
                    }
                }
            }
        }
    }, [containerRef]);
    react_use_1.useKey('Escape', onClose);
    react_use_1.useKey('Tab', handleTab);
    if (portalElement) {
        return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(NoScroll_1.default, null),
            react_1.default.createElement(styles_1.Cover, { ref: coverRef, onClick: handleClickCover }),
            children({ ref: containerRef, role: 'dialog', 'aria-label': title })), portalElement);
    }
    return null;
};
exports.BaseModal = BaseModal;
exports.default = exports.BaseModal;
